import { createAction } from 'redux-actions';
import { Map as ImmutableMap } from 'immutable';

import { rootUiActions, rootUiTypes } from 'companion-app-components/flux/root-ui';

export const DIALOG_TYPE = 'INDIVIDUAL_CATEGORY_ANNUAL_BUDGET';

export const showIndividualCategoryAnnualBudget = createAction(
  rootUiActions.createDialog.toString(),
  (budgetId, categoryId, clickedMonthDate, allCategoryIdsOfBudget, isEverythingElse, displayLabel) => rootUiTypes.mkRootUiData({
    type: DIALOG_TYPE,
    allowNesting: true,
    props: ImmutableMap({
      budgetId,
      categoryId,
      clickedMonthDate,
      allCategoryIdsOfBudget,
      isEverythingElse,
      displayLabel,
    }),
  }),
);
